import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Button, ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { ContentEditorComponent, EditorContent } from '../../../utility/content-editor/content-editor.component';
import { MessageService } from 'primeng/api';
import { EssayPilotService } from '../../../services/essay-pilot/essay-pilot.service';
import { CommonModule } from '@angular/common';
import { EssayAnswerResponse } from '../../../models/essay-pilot/essayAnswerResponse';
import { DialogModule } from 'primeng/dialog';
import { RecentSubmissionsComponent } from "../recent-submissions/recent-submissions.component";
import { PastEssaySubmissionResponse } from '../../../models/essay-pilot/pastEssaySubmissionResponse';
import { UserSelectors } from '../../../states/user/user-selector';
import { Store } from '@ngxs/store';
import { UserStateModel } from '../../../states/user/user-state-model';
import { essayOptions } from '../essay-pilot.component';
import { of, switchMap } from 'rxjs';
import { EssayCommentResponse } from '../../../models/essay-pilot/essayCommentResponse';
@Component({
  selector: 'app-institute-essay-editor',
  standalone: true,
  imports: [ButtonModule, DialogModule, ContentEditorComponent, FormsModule, CommonModule, RecentSubmissionsComponent],
  templateUrl: './institute-essay-editor.component.html',
  styleUrls: ['./institute-essay-editor.component.scss'],
})
export class InstituteEssayEditorComponent implements OnInit {
  @Input() essay!: EssayAnswerResponse;
  @Input() instituteId!: string;
  @Input() wordLimit: number | undefined;
  selectedEssay: essayOptions | undefined;
  latestSubmission: PastEssaySubmissionResponse | undefined;
  submitted: boolean = false;
  initialContent: string = ''
  isLoading: boolean = false;
  commentList: EssayCommentResponse[] = [];
  constructor(
    private cdr: ChangeDetectorRef,
    private essayService: EssayPilotService,
    private messageService: MessageService,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.initialContent = this.essay.htmlAnswer ?? '';
  }

  visible: boolean = false;
  isLoadingPastSubmssions: boolean = false;
  user: UserStateModel | undefined;

  pastSubmissions: PastEssaySubmissionResponse[] = [];
  showDialog() {
    this.visible = true;
  }

  onEssayContentChange($event: EditorContent) {
    this.essay.answer = $event.textValue;
    this.essay.htmlAnswer = $event.htmlValue;
    this.cdr.detectChanges(); // Ensures bindings update
  }

  get wordCount(): number {
    // this.getPendingComments();
    return this.essay?.answer
      ? this.essay.answer.trim().split(/\s+/).filter((word) => word).length
      : 0;
  }

  onSubmit() {
    this.submitted = true;
    if (!this.essay.answer 
      // || this.wordCount > 650
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 
        // this.wordCount > 650
          // ? 
          // `Words can't exceed 650 limit`
          // : 
          'Content is required',
      });
      return;
    }
    this.isLoading = true;
    const saveOrUpdate$ = this.essay.id
      ? this.essayService.updateStudentEssayAnswer(this.essay.id.toString(), {
        question: this.essay.question ?? '',
        answer: this.essay.answer,
        htmlAnswer: this.essay.htmlAnswer ?? '',
        instituteId: this.instituteId
      })
      : this.essayService.saveStudentEssayAnswer({
        question: this.essay.question ?? '',
        answer: this.essay.answer,
        htmlAnswer: this.essay.htmlAnswer ?? '',
        instituteId: this.instituteId
      });

    saveOrUpdate$.subscribe({
      next: () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Answer is ${this.essay.id ? 'updated' : 'saved'
            }!`,
        });
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error saving/updating essay:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while saving your essay.',
        });
      },
    });
  }

  getRecentSubmissions() {
    this.isLoadingPastSubmssions = true;
    this.essayService.getPastSubmissions({
      question: this.essay.question ?? '',
      instituteId: this.instituteId,
      studentId: this.user?.id ?? '',
    }).subscribe({
      next: (submissions) => {
        this.isLoadingPastSubmssions = false;
        this.pastSubmissions = submissions.result ?? [];
        if (submissions.result.length > 0) {
          this.showDialog();
        }
        else {
          this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
        }
      },
      error: (error) => {
        this.isLoadingPastSubmssions = false;
        this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
      },
    });
  }

  getPendingComments() {
    this.essayService.getPastSubmissions({
      question: this.essay.question ?? '',
      studentId: this.user?.id ?? '',
      instituteId: this.instituteId,
    }).pipe(
      switchMap(submissions => {
        this.latestSubmission = submissions.result[submissions.result.length - 1] ?? undefined;
        console.log(this.latestSubmission);
        if (this.latestSubmission?.id) {
          return this.essayService.getEssayComments({
            pastEssaySubmissionId:this.latestSubmission?.id,
            status: 0
          });
        } else {
          // this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'No Submission found', life: 3000 });
          return of({ result: [] }); // Return an observable with an empty result
        }
      })
    ).subscribe({
      next: (response) => {
        this.commentList = response.result;
      },
      error: (err) => {
        console.warn(`error while retriving essay comment list:${err}`);
      }
    });
  }

  updateCommentStatus(commentId: number) {
    this.isLoading = true;
    this.essayService.updateCommentStatus(commentId).subscribe({
      next: (response) => {
        this.isLoading = false;
        const index = this.commentList.findIndex(comment => comment.id === commentId);
        if(index > -1){
          this.commentList.splice(index, 1);
        }
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment status updated successfully!' });
      },
      error:(err) => {
        this.isLoading = false;
        console.warn(`error while updating comment status:${err}`);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while updating comment status.' });
      }
    })
  }

  getUser(){
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.user = response;
        this.getPendingComments();
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }
}
